/* eslint-disable no-continue */
import { SUMMARY_REPORT_PRODUCT_GROUP_ENUM, SUMMARY_REPORT_PRODUCT_TYPE_ENUM } from 'constant';
import { ASYNC_CONSTANT } from 'constant/summary-report.constant';

export const handleResearchResult = (
  researchResult,
  mutateProducts,
  summaryReportId,
  summaryReportProductTypeId,
  summaryReportProductGroupId,
  opts,
  isCreated = true
) => {
  let order = 0;
  let { productFileFormData, count } = opts;
  // eslint-disable-next-line no-restricted-syntax, no-unsafe-optional-chaining
  for (const research of researchResult) {
    order += 1;
    if (research?.isUpdateNewValue || !research?.id) {
      if (count === ASYNC_CONSTANT.NUMBER_PRODUCT) {
        mutateProducts.push(productFileFormData);
        productFileFormData = new FormData();
        if (isCreated) {
          productFileFormData.append('summaryReportId', summaryReportId);
        }
        count = 0;
      }
      const researchSender = {
        summaryReportProductGroupId,
        researchKpiGroupId: research?.researchKpiGroupId,
        researchKpiId: research?.researchKpiId,
        productDetail: research?.productDetail,
        hasFile: false,
        order,
      };
      if (summaryReportProductTypeId) {
        researchSender.summaryReportProductTypeId = summaryReportProductTypeId;
      }
      if (research?.file) {
        productFileFormData.append('productFiles', research?.file);
        researchSender.hasFile = true;
      }
      if (research?.id) {
        researchSender.id = research?.id;
      }
      productFileFormData.append('summaryReportProducts', JSON.stringify(researchSender));
      count += 1;
    }
  }
  return [count, productFileFormData];
};

export const getSummaryReportProductSpecificType = (summaryReportProductType) => {
  const softProductType = summaryReportProductType.find(
    (productType) => productType.code === SUMMARY_REPORT_PRODUCT_TYPE_ENUM.SOFT_PRODUCT
  );
  const hardProductType = summaryReportProductType.find(
    (productType) => productType.code === SUMMARY_REPORT_PRODUCT_TYPE_ENUM.HARD_PRODUCT
  );
  const scientificPublicationType = summaryReportProductType.find(
    (productType) => productType.code === SUMMARY_REPORT_PRODUCT_TYPE_ENUM.SCIENTIFIC_PUBLICATION
  );

  return [softProductType, hardProductType, scientificPublicationType];
};

export const getSummaryReportGroup = (summaryReportProductGroup) => {
  const scientificPublicationGroup = summaryReportProductGroup.find(
    (productGroup) => productGroup.code === SUMMARY_REPORT_PRODUCT_GROUP_ENUM.SCIENTIFIC_PUBLICATION
  );
  const trainingResultGorup = summaryReportProductGroup.find(
    (productGroup) => productGroup.code === SUMMARY_REPORT_PRODUCT_GROUP_ENUM.TRAINING_RESULT
  );
  const intellectualPropertyGroup = summaryReportProductGroup.find(
    (productGroup) => productGroup.code === SUMMARY_REPORT_PRODUCT_GROUP_ENUM.INTELLECTUAL_PROPERTY
  );

  return [scientificPublicationGroup, trainingResultGorup, intellectualPropertyGroup];
};
